import { StringSideType, NumericSideType } from '../models/enums';

export const stringToNumericSideType = (value: string | undefined): NumericSideType => {
	if (!value) {
		return NumericSideType.Buy;
	}
	return value.toUpperCase() === 'BUY' ? NumericSideType.Buy : NumericSideType.Sell;
};

export const numericToStringSideType = (value: number | undefined): StringSideType => {
	if (value === undefined) {
		return StringSideType.Buy;
	}
	return value === 0 ? StringSideType.Buy : StringSideType.Sell;
};
